import { render, staticRenderFns } from "./GoodsSearchAutoComplete.vue?vue&type=template&id=0c23687b&scoped=true&"
import script from "./GoodsSearchAutoComplete.vue?vue&type=script&lang=js&"
export * from "./GoodsSearchAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSearchAutoComplete.vue?vue&type=style&index=0&id=0c23687b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23687b",
  null
  
)

export default component.exports